import colors from 'app/styles/colors';
import { reactStyles } from 'app/utils';

export const surveyStyles = reactStyles({
  question: {
    fontWeight: 'bold',
    color: colors.primary,
    fontSize: '18px',
    lineHeight: '1.875rem',
  },
});
